import { render, staticRenderFns } from "./SampleSet.vue?vue&type=template&id=0d0bcfa7"
import script from "./SampleSet.vue?vue&type=script&lang=js"
export * from "./SampleSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports